import React from "react";
import {Table} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import moment from "moment";
import Accordion from "@material-ui/core/Accordion";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import {ExpandMoreTwoTone} from "@material-ui/icons";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import SwmsPartThree from "./SwmsPartThree";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import MuiTable from "../common/MuiTable";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

const muiColumnsHazards = [
    { title: t('swms.columns.jobStep'), field: 'jobStep', headerStyle: { width: "10%", background: "lightblue" }},
    { title: t('swms.columns.consequence'),
        field: 'inherentRiskConsequence',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: {
            insignificant : t('swms.lookup.consequence.insignificant'),
            minor : t('swms.lookup.consequence.minor'),
            moderate: t('swms.lookup.consequence.moderate'),
            major: t('swms.lookup.consequence.major'),
            catastrophic: t('swms.lookup.consequence.catastrophic')
        },
    },
    { title: t('swms.columns.likelihood'),
        field: 'inherentRiskLikelihood',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: {
            certain : t('swms.lookup.likelihood.certain'),
            likely : t('swms.lookup.likelihood.likely'),
            possible: t('swms.lookup.likelihood.possible'),
            unlikely: t('swms.lookup.likelihood.unlikely'),
            rare: t('swms.lookup.likelihood.rare')
        },
    },
    {
        title: t('swms.columns.inherentRiskRating'),
        field: 'calculatedInherentRisk',
        editComponent: (props) => {
            let color = 'black';
            let backgroundColor = 'white';
            if ((['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['unlikely', 'rare', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.inherentRiskConsequence))) {
                color = 'green';
                props.rowData.calculatedInherentRisk = t('swms.riskScores.low');
            } else if ((props.rowData.inherentRiskLikelihood === 'likely' && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                props.rowData.calculatedInherentRisk = t('swms.riskScores.moderate');
            } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['certain', 'likely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
                || (props.rowData.inherentRiskLikelihood === 'rare' && props.rowData.inherentRiskConsequence === 'catastrophic')) {
                color = 'orange';
                props.rowData.calculatedInherentRisk = t('swms.riskScores.high');
            } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'catastrophic')) {
                color = 'red';
                props.rowData.calculatedInherentRisk = t('swms.riskScores.acute');
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculatedInherentRisk}</div>;
        },
        render: (rowData) => {
            let color = 'black';
            let backgroundColor = 'white';
            let calculatedInherentRisk = '';
            if ((['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.inherentRiskConsequence))) {
                color = 'green';
                calculatedInherentRisk = t('swms.riskScores.low');
            } else if ((rowData.inherentRiskLikelihood === 'likely' && rowData.inherentRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                calculatedInherentRisk = t('swms.riskScores.moderate');
            } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'insignificant')
                || (['certain', 'likely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
                || (rowData.inherentRiskLikelihood === 'rare' && rowData.inherentRiskConsequence === 'catastrophic')) {
                color = 'orange';
                calculatedInherentRisk = t('swms.riskScores.high');
            } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'catastrophic')) {
                color = 'red';
                calculatedInherentRisk = t('swms.riskScores.acute');
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculatedInherentRisk}</div>;
        }
    },
    { title: t('swms.columns.controlMeasure'), field: 'controlMeasure', type: "textarea", headerStyle: { width: "25%", background: "lightblue" } },
    { title: t('swms.columns.consequence'),
        field: 'residualRiskConsequence',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: {
            insignificant : t('swms.lookup.consequence.insignificant'),
            minor : t('swms.lookup.consequence.minor'),
            moderate: t('swms.lookup.consequence.moderate'),
            major: t('swms.lookup.consequence.major'),
            catastrophic: t('swms.lookup.consequence.catastrophic')
        },
    },
    { title: t('swms.columns.likelihood'),
        field: 'residualRiskLikelihood',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: {
            certain : t('swms.lookup.likelihood.certain'),
            likely : t('swms.lookup.likelihood.likely'),
            possible: t('swms.lookup.likelihood.possible'),
            unlikely: t('swms.lookup.likelihood.unlikely'),
            rare: t('swms.lookup.likelihood.rare')
        },
    },
    {
        title: t('swms.columns.residualRiskRating'),
        field: 'calculateResidualRisk',
        editComponent: (props) => {
            let color = 'black';
            let backgroundColor = 'white';
            if ((['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.residualRiskConsequence))) {
                color = 'green';
                props.rowData.calculateResidualRisk = t('swms.riskScores.low');
            } else if ((props.rowData.residualRiskLikelihood === 'likely' && props.rowData.residualRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                props.rowData.calculateResidualRisk = t('swms.riskScores.moderate');
            } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'insignificant')
                || (['certain', 'likely'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
                || (props.rowData.residualRiskLikelihood === 'rare' && props.rowData.residualRiskConsequence === 'catastrophic')) {
                color = 'orange';
                props.rowData.calculateResidualRisk = t('swms.riskScores.high');
            } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'catastrophic')) {
                color = 'red';
                props.rowData.calculateResidualRisk = t('swms.riskScores.acute');
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculateResidualRisk}</div>;
        },
        render: (rowData) => {
            let color = 'black';
            let backgroundColor = 'white';
            let calculateResidualRisk = '';
            if ((['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.residualRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.residualRiskConsequence))) {
                color = 'green';
                calculateResidualRisk = t('swms.riskScores.low');
            } else if ((rowData.residualRiskLikelihood === 'likely' && rowData.residualRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                calculateResidualRisk = t('swms.riskScores.moderate');
            } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'insignificant')
                || (['certain', 'likely'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
                || (rowData.residualRiskLikelihood === 'rare' && rowData.residualRiskConsequence === 'catastrophic')) {
                color = 'orange';
                calculateResidualRisk = t('swms.riskScores.high');
            } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'catastrophic')) {
                color = 'red';
                calculateResidualRisk = t('swms.riskScores.acute');
            }
            return <span style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculateResidualRisk}</span>;
        }
    }
];

const muiColumnsHazardsWorkers = [
    { title: t('swms.columns.workerName'), field: 'name'},
    { title: t('swms.columns.jobTitle'), field: 'jobTitle', headerStyle: { width: "20%" } },
    { title: t('swms.columns.company'), field: 'company', headerStyle: { width: "20%" } },
    { title: t('swms.columns.signature'), field: 'signature', type: "signature", headerStyle: { width: "20%" } },
    { title: t('swms.columns.date'), field: 'date', type: "date", headerStyle: { width: "20%" } },
];

class SwmsHazards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.state.id,
            hazards: this.props.state.hazards,
            hazardsWorkers: this.props.state.hazardsWorkers,
        };
        this.onChange = this.onChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onModalOpen = this.onModalOpen.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
        this.handleAddHazard = this.handleAddHazard.bind(this);
        this.handleAddHazardWorker = this.handleAddHazardWorker.bind(this);
        this.handleUpdateHazards = this.handleUpdateHazards.bind(this);
        this.handleUpdateHazardWorker = this.handleUpdateHazardWorker.bind(this);
        this.handleDeleteHazard = this.handleDeleteHazard.bind(this);
        this.handleDeleteHazardWorker = this.handleDeleteHazardWorker.bind(this);
    }

    saveSwms(isContinueEditing) {
        this.props.saveSwms(isContinueEditing, this.state.hazards, this.state.hazardsWorkers);
    }

    handleAddHazard(data) {
        let list = this.state.hazards;
        list.push(data);
        this.setState({
            hazards: list
        }, () => this.saveSwms(true));
    }

    handleAddHazardWorker(data) {
        let list = this.state.hazardsWorkers;
        list.push(data);
        this.setState({
            hazardsWorkers: list
        }, () => this.saveSwms(true));
    }

    handleDeleteHazard(toDelete) {
        let hazards = [];
        const index = this.state.hazards.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.hazards.length; i < l; i++) {
            if (i !== index) {
                hazards.push(this.state.hazards[i]);
            }
        }
        this.setState({hazards: hazards}, () => this.saveSwms(true));
    }

    handleDeleteHazardWorker(toDelete) {
        let hazardsWorkers = [];
        const index = this.state.hazardsWorkers.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.hazardsWorkers.length; i < l; i++) {
            if (i !== index) {
                hazardsWorkers.push(this.state.hazardsWorkers[i]);
            }
        }
        this.setState({hazardsWorkers: hazardsWorkers}, () => this.saveSwms(true));
    }

    handleUpdateHazards(toUpdate) {
        for (let i = 0, l = this.state.hazards.length; i < l; i++) {
            if (this.state.hazards[i].id === toUpdate.id) {
                this.state.hazards[i].jobStep = toUpdate.jobStep;
                this.state.hazards[i].inherentRiskLikelihood = toUpdate.inherentRiskLikelihood;
                this.state.hazards[i].inherentRiskConsequence = toUpdate.inherentRiskConsequence;
                this.state.hazards[i].controlMeasure = toUpdate.controlMeasure;
                this.state.hazards[i].residualRiskLikelihood = toUpdate.residualRiskLikelihood;
                this.state.hazards[i].residualRiskConsequence = toUpdate.residualRiskConsequence;
            }
        }
        this.saveSwms(true);
    }

    handleUpdateHazardWorker(toUpdate) {
        for (let i = 0, l = this.state.hazardsWorkers.length; i < l; i++) {
            if (this.state.hazardsWorkers[i].id === toUpdate.id) {
                this.state.hazardsWorkers[i].name = toUpdate.name;
                this.state.hazardsWorkers[i].signature = toUpdate.signature;
                this.state.hazardsWorkers[i].jobTitle = toUpdate.jobTitle;
                this.state.hazardsWorkers[i].company = toUpdate.company;
                this.state.hazardsWorkers[i].date = toUpdate.date;
            }
        }
        this.saveSwms(true);
    }

    onChange(event) {
        console.log('on change called');
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }
    isValid() {
        return true;
    }
    onDateChange(date, fieldName) {
        console.log('on date change called');
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    onModalOpen() {
        this.setState({
            zoomedInModalShow: true,
        });
    }

    onModalClose() {
        this.setState({
            zoomedInModalShow: false,
        });
    }

    onSignatureDrawn(fileName, sigPad) {
        console.log('on signature drawn called');
        this.props.onChangeHandler();
        this.props.onSignatureDrawn(fileName, sigPad);
    }

    render() {
        let {state} = this;

        return <React.Fragment>
            <Accordion defaultExpanded>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreTwoTone />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ backgroundColor: 'blue', color: 'white'}}
            >
                <Grid item xs={8}>
                    <Typography component="h6" variant="subtitle1">
                        { t('swms.scopeTitle') }
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component="h6" variant="subtitle1">
                        { t('swms.highRiskConstructionWork') }
                    </Typography>
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ padding: '0px' }}>
                <SwmsPartThree state={this.state} onChangeHandler={this.props.onChangeHandler}/>
            </ExpansionPanelDetails>
        </Accordion>
        <Accordion defaultExpanded>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreTwoTone />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ backgroundColor: 'blue', color: 'white'}}
            >
                <Grid item xs={12}>
                    <Typography component="h6" variant="subtitle1">
                        { t('swms.riskMatrix.title') }
                    </Typography>
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ padding: '0px' }}>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="3">{ t('swms.riskMatrix.step1Title') }</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}/>
                                    <th style={{ padding: "20px", width: "40%" }}>{ t('swms.riskMatrix.criteria') }</th>
                                    <th style={{ padding: "20px", width: "40%" }}>{ t('swms.riskMatrix.description') }</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.certain') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.certain.criteria') || '' }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.certain.description') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.likely') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.likely.criteria') || '' }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.likely.description') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.possible') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.possible.criteria') || '' }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.possible.description') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.unlikely') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.unlikely.criteria') || '' }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.unlikely.description') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.rare') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.rare.criteria') || '' }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.likelihoodDescriptions.rare.description') }</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="3">{ t('swms.riskMatrix.step2Title') }</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}>{ t('swms.riskMatrix.levelOfEffect') }</th>
                                    <th style={{ padding: "20px", width: "80%" }}>{ t('swms.riskMatrix.exampleOfEachLevel') }</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.consequence.insignificant') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.examples.insignificant') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.consequence.minor') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.examples.minor') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.consequence.moderate') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.examples.moderate') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.consequence.major') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.examples.major') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.consequence.catastrophic') }</td>
                                    <td style={{ padding: "20px" }}>{ t('swms.examples.catastrophic') }</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="6">{ t('swms.riskMatrix.step3Title') }</th>
                                </tr>
                                <tr>
                                    <th colSpan="6" style={{padding: "20px", width: "20%"}}>{ t('swms.riskMatrix.consequenceHeader') }</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.certain') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.likely') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>{ t('swms.riskScores.moderate') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.possible') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>{ t('swms.riskScores.low') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>{ t('swms.riskScores.moderate') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.unlikely') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>{ t('swms.riskScores.low') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>{ t('swms.riskScores.low') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>{ t('swms.riskScores.moderate') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>{ t('swms.riskScores.acute') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>{ t('swms.lookup.likelihood.rare') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>{ t('swms.riskScores.low') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>{ t('swms.riskScores.low') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>{ t('swms.riskScores.moderate') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>{ t('swms.riskScores.high') }</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="2">{ t('swms.riskMatrix.step4Title') }</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}>{ t('swms.riskMatrix.score') }</th>
                                    <th style={{ padding: "20px", width: "80%" }}>{ t('swms.riskMatrix.action') }</th>
                                </tr>
                            </TableHead>
                            <TableBody style={{ textAlign: "center" }}>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4<br/>{ t('swms.riskScores.acuteShort') }</td>
                                    <td style={{ padding: "20px" }}><b>{ t('swms.actions.acuteTitle') }</b> { t('swms.actions.acute') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3<br/>{ t('swms.riskScores.highShort') }</td>
                                    <td style={{ padding: "20px" }}><b>{ t('swms.actions.highTitle') }</b> { t('swms.actions.high') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2<br/>{ t('swms.riskScores.moderateShort') }</td>
                                    <td style={{ padding: "20px" }}><b>{ t('swms.actions.moderateTitle') }</b> { t('swms.actions.moderate') }</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1<br/>{ t('swms.riskScores.lowShort') }</td>
                                    <td style={{ padding: "20px" }}><b>{ t('swms.actions.lowTitle') }</b> { t('swms.actions.low') }</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <div style={{ backgroundColor: 'yellow', padding: "30px" }}>
                            <Typography component="h6" variant="subtitle1">
                                { t('swms.abbreviations.ir') }
                            </Typography>
                            <br/>
                            <Typography component="h6" variant="subtitle2">
                                { t('swms.abbreviations.rr') }
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper square>
                            <MuiTable
                                title={ t('swms.tables.hazardsTitle') }
                                columns={muiColumnsHazards}
                                data={state.hazards}
                                onAdd={this.handleAddHazard}
                                onUpdate={this.handleUpdateHazards}
                                onDelete={this.handleDeleteHazard}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <div style={{ backgroundColor: 'yellow', padding: "30px" }}>
                            <Typography component="h6" variant="subtitle1">
                                { t('swms.consultation.heading') }
                            </Typography>
                            <br/>
                            <Typography component="h6" variant="subtitle2">
                                { t('swms.consultation.subtext') }
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper square>
                            <MuiTable
                                title={ t('swms.tables.hazardWorkersTitle') }
                                columns={muiColumnsHazardsWorkers}
                                data={state.hazardsWorkers}
                                onAdd={this.handleAddHazardWorker}
                                onUpdate={this.handleUpdateHazardWorker}
                                onDelete={this.handleDeleteHazardWorker}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </ExpansionPanelDetails>
        </Accordion>
        </React.Fragment>;
    }
}

export default withStyles(classes)(SwmsHazards);
